import { connect } from "react-redux";

import { getInvitedMembersList } from "../../Members/membersActions";
import {
  bulkGustoInvite,
  deleteGustoIntegration,
  getGustoCompanyDetails,
  getGustoEmployeeList,
  getIntegrationsFeatures,
  updateGustoCompanyLogo,
  updateIntegrationsFeatures,
} from "../integrationsActions";
import GustoSettings from "./GustoSettings";

const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,

  // features list
  featuresLoading: state.integrations.integrationFeaturesLoading,
  featuresList: state.integrations.featuresList,

  // gusto integration
  employeeList: state.integrations.gustoEmployeeList,
  employeeLoading: state.integrations.gustoEmployeeLoading,
  // integration: state.integrations.integration,
  companyDetails: state.integrations.gustoCompanyDetails,
  companyLoading: state.integrations.gustoCompanyLoading,
  bulkInviteLoading: state.integrations.gustoBulkInviteLoading,
  deleteLoading: state.integrations.gustoDeleteLoading,

  // member invited list
  memberInvitedLoading: state.member.isLoading,
  memberInvitedList: state.member.invitedMembersList,
  memberInvitedCount: state.member.totalMembersCount,
});

const mapDispatchToProps = dispatch => ({
  getCompanyDetails: payload => dispatch(getGustoCompanyDetails(payload)),
  deleteIntegration: payload => dispatch(deleteGustoIntegration(payload)),
  getEmployeeList: payload => dispatch(getGustoEmployeeList(payload)),
  updateCompanyLogo: payload => dispatch(updateGustoCompanyLogo(payload)),
  bulkInvite: payload => dispatch(bulkGustoInvite(payload)),
  getInvitedList: payload => dispatch(getInvitedMembersList(payload)),

  getFeatures: payload => dispatch(getIntegrationsFeatures(payload)),
  updateFeatures: payload => dispatch(updateIntegrationsFeatures(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GustoSettings);
